import { render, staticRenderFns } from "./Servizi-fotografici.vue?vue&type=template&id=5701f940&scoped=true&"
import script from "./Servizi-fotografici.vue?vue&type=script&lang=js&"
export * from "./Servizi-fotografici.vue?vue&type=script&lang=js&"
import style0 from "./Servizi-fotografici.vue?vue&type=style&index=0&id=5701f940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701f940",
  null
  
)

export default component.exports